<template>
  <div class="emoji-box">
    <!-- 基础表情 -->
    <div class="emoji" v-show="isBaseEmoji">
      <span class="emoji-item" v-for="(item, index) in emojiJSON" @click="choose('emoji', item.codePoint, item)">
        {{ item.codePoint }}
      </span>
    </div>

    <!-- 系列表情 -->
    <div class="emoji" v-show="!isBaseEmoji && props.isTinymce">
      <p class="series-name" v-if="isCN">{{ state.seriesName }}</p>
      <div class="expression-box">
        <div v-for="(item, index) in state.emojiImg">
          <el-tooltip placement="top" effect="customized" :show-after="600">
            <template #content>
              <img :src="item.originalImage" class="emoji-img" />
              <p class="emoji-name">{{ item.name }}</p>
            </template>
            <div class="expression" :style="{ backgroundImage: `url(${item.previewImage})` }" @click="choose('img', item.originalImage, item)"></div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="icon-tabs">
      <swiper class="swiper-container" slidesPerView="auto">
        <swiper-slide style="width: auto">
          <div class="icon-kind" :class="isBaseEmoji && 'active-kind'" @click="showBaseEmoji"><svg-icon name="icon-emoji" /></div>
        </swiper-slide>
        <swiper-slide v-for="(item, index) in state.tabIconList" style="width: auto" :class="state.seriesIndex === index && !isBaseEmoji && 'active-kind'">
          <div class="icon-kind" @click="showSeriesExpression(item.jsonUrl, index, item.name, item.id)" v-if="props.isTinymce">
            <img :src="item.icon" />
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, reactive, getCurrentInstance } from 'vue'
import { storeToRefs } from 'pinia'
import http from '@/service'

import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'

import { useSystemStore } from '@/stores/system'
import emojiJSON from '@/assets/emojis/emoji.json'
import { useRoute } from 'vue-router'

const route = useRoute()
const systemStore = useSystemStore()
const { cloudConfig } = storeToRefs(systemStore)
const { proxy } = getCurrentInstance()
const emit = defineEmits(['selectEmoji'])

const props = defineProps({
  //判断是编辑器还是普通输入框
  isTinymce: {
    type: Boolean,
    default: true
  },
  // 埋点-评论信息
  gaCommentMess: {
    type: Object,
    default: () => {}
  },
  // 埋点-评论回复对应的评论
  commentData: {
    type: Object,
    default: () => {}
  }
})

const isCN = import.meta.env.VITE_COUNTRY === 'CHINA'

const state = reactive({
  tabIconList: [],
  emojiImg: [],
  seriesName: '',
  seriesIndex: 0
})

const isBaseEmoji = ref(true)
const showBaseEmoji = () => {
  isBaseEmoji.value = true
}

let stickersLocal = []
let stickersIdArr = []
const showSeriesExpression = async (jsonUrl, index, name, id) => {
  state.seriesIndex = index
  state.seriesName = name
  isBaseEmoji.value = false
  try {
    if (!stickersIdArr.includes(id)) {
      let response = await fetch(jsonUrl)
      let jsonText = await response.json()
      state.emojiImg = jsonText.stickers
      stickersIdArr.push(id)
      stickersLocal.push({ id: id, emojis: jsonText.stickers, name: name })
      localStorage.setItem('seriesEmoji', JSON.stringify(stickersLocal))
    } else {
      let dataArr = JSON.parse(localStorage.getItem('seriesEmoji'))
      if (dataArr) {
        state.emojiImg = dataArr.find(item => item.id === id)?.emojis
        state.seriesName = dataArr.find(item => item.id === id)?.name
      }
    }
  } catch (error) {
  }
}

// 埋点
const setGaData = (type, item) => {
  if (props.gaCommentMess) {
    // 评论
    let gaParams = {
      screen_name: route.name,
      thread_category: props.gaCommentMess?.type,
      thread_id: route.params.id,
      circle_id: props.gaCommentMess?.circleBasicInfo?.id,
      circle_name: props.gaCommentMess?.circleBasicInfo?.name,
      button_name: (type === 'img' ? state.seriesName : 'base emoji') + ' - ' + item.name
    }
    if (props.commentData) {
      gaParams.post_id = props.commentData?.parentCid || props.commentData?.id
    }
    proxy.$ga(props.commentData ? (props.commentData.isEdit ? 'post_edit_select_emoji' : 'post_reply_select_emoji') : 'thread_reply_select_emoji', gaParams)
  } else {
    // 发帖
    proxy.$ga('publish_new_threads_emoji', {
      screen_name: route.name,
      thread_category: route.params.type === 'moment' ? 2 : route.params.type === 'article' ? 1 : 4,
      button_name: (type === 'img' ? state.seriesName : 'base emoji') + ' - ' + item.name
    })
  }
}
   
// 系列表情插入的个数限制
const isShortArticle = route.params.type === 'moment'
const isLongArticle = route.params.type === 'article' || route.params.type === 'poll'
let limit = isShortArticle
  ? cloudConfig.value?.shortArticleEmojiLimit
  : isLongArticle
  ? cloudConfig.value?.longArticleEmojiLimit
  : cloudConfig.value.commentEmojiLimit

const choose = (type, point, item) => {
  if (!props.isTinymce) {
    emit('selectEmoji', point)
  } else {
    setGaData(type, item)
    let ed = tinymce.activeEditor
    let range = ed.selection.getRng()
    let emojiNode
    if (type === 'img') {
      // 系列表情
      if (limit) {
        let typeList = ed.getContent().match(/data-type=".*?"/gi) || []
        let len = 0
        typeList.map(item => {
          if (item.includes('sticker_self')) {
            len++
          }
        })
        if (len == limit) {
          proxy.$toast({
            message: proxy.$t('emojiLimitToast', {
              number: limit
            })
          })
          return
        }
      }
      emojiNode = ed.getDoc().createElement('img')
      emojiNode.setAttribute('data-type', 'sticker_self')
      emojiNode.setAttribute('data-value', item.id)
      emojiNode.className = 'emojistyle'
      emojiNode.src = point
    } else {
      // emoji
      emojiNode = ed.getDoc().createElement('span')
      emojiNode.innerHTML = point
    }
    range.insertNode(emojiNode)
    // 光标聚焦并移动至插入的表情后
    // ed.execCommand('seleceAll')
    ed.selection.getRng().collapse()
    ed.fire('change')
    // ed.focus()
  }
}

const getSeriesEmojiList = async () => {
  const { code, data } = await http.getSeriesEmojiList()
  state.tabIconList = data
}

onMounted(() => {
  getSeriesEmojiList()
  localStorage.removeItem('seriesEmoji')
})
</script>
<style scoped>
.emoji-box {
  width: 400px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  .emoji {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    width: 368px;
    height: 232px;
    border-radius: 8px;
    padding: 18px 16px;
    overflow-y: scroll;
    justify-content: space-between;
    .emoji-item {
      width: 40px;
      height: 40px;
      line-height: 40px !important;
      text-align: center;
      cursor: pointer;
      font-size: 20px;
      &:last-child {
        margin-right: auto;
      }
      &:hover {
        background-color: var(--background-pressed);
        border-radius: 4px;
      }
    }
  }

  .series-name {
    color: var(--background-hint);
    text-align: left;
    width: 100%;
    margin-left: 10px;
    margin-bottom: 2px;
  }

  .expression-box {
    width: calc(100vw - 16px);
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    .emoji-pop {
      width: 100px;
      height: 100px;
    }
    .expression {
      width: 52px;
      height: 52px;
      background: transparent;
      background-size: 42px;
      background-repeat: no-repeat;
      background-position: center;
      margin: 6px 10px;
      border-radius: 4px;
      &:hover {
        background-color: var(--background-pressed);
        cursor: pointer;
      }
    }
  }

  .icon-tabs {
    height: 46px;
    background-color: #f8f9fa;
    display: flex;
    border-top: 1px solid #f5f5f5;
    .icon-kind {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 46px;
      font-size: 28px;
      cursor: pointer;
      img {
        width: 28px;
        background: transparent;
      }
    }
    .active-kind {
      background: #fff;
    }
  }

  /*高宽 背景 尺寸*/
  ::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  /*定义滑块
 内阴影+圆角*/
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    height: 40px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.03);
    background-color: #e6e6e6;
  }
}
.swiper-container {
  width: 100%;
}
</style>
<style>
.el-popper.is-customized {
  padding: 10px;
  background: #fff;
  box-shadow: 0px 6px 20px 0px rgba(0, 0, 0, 0.08);
  .emoji-img {
    width: 56px;
    height: 56px;
    display: block;
    margin: 0 auto;
  }
  .emoji-name {
    width: 78px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.is-customized .el-popper__arrow {
  display: block !important;
}
.is-customized .el-popper__arrow::before {
  background: #fff;
}
</style>
